import {Values} from "@wix/devzai-utils-common";

export const DoppeAutoMembershipPlansType = {
    Latest: 'Latest'
} as const;

export type DoppeAutoMembershipPlantType = Values<typeof DoppeAutoMembershipPlansType>;